export default function localize(key: string): string {
	return (window.umeLocalize && window.umeLocalize[key]) || '';
}

export const l = localize;
